import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import RouteItems from '@/components/RouteItems';
import routes from '@/routes';
import { Domains } from '@/domains';
import { globalStore } from '@/GlobalStore';

interface AppProps {
  onLoad?: () => void;
}

const App: React.FC<AppProps> = observer(({ onLoad }) => {
  useEffect(() => {
    void globalStore.init().catch((err) => {
      console.error('[sparrow] init failed', err);
    });
    onLoad?.();
  }, [onLoad]);

  return (
    <Domains.Provider value={{}}>
      <RouteItems config={routes} />
    </Domains.Provider>
  );
});

export default App;
